var _excluded = ["autotagging-flora", "data-flora-text", "data-autotagging-flora-section", "viewport", "fontSize", "fontWeight", "textDecoration", "screenReaderOnly", "children", "as"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { forwardRef } from '@grupoboticario/flora-react-system';
import { StyledTypography } from './styles';
import { useFloraTypography } from './useFloraTypography';
export var FloraTypography = forwardRef((_ref, forwardedRef) => {
  var {
    'autotagging-flora': autotaggingFlora = 'off',
    'data-flora-text': dataFloraText,
    'data-autotagging-flora-section': dataAutotaggingFloraSection = '',
    viewport = 'desktop',
    fontSize,
    fontWeight = 'regular',
    textDecoration = 'none',
    screenReaderOnly = false,
    children,
    as = 'p'
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  useFloraTypography(children);
  return /*#__PURE__*/React.createElement(StyledTypography, _extends({}, props, {
    ref: forwardedRef,
    "data-flora": "typography",
    "autotagging-flora": autotaggingFlora,
    "data-flora-text": dataFloraText,
    "data-autotagging-flora-section": dataAutotaggingFloraSection,
    viewport: viewport,
    fontSize: fontSize,
    fontWeight: fontWeight,
    textDecoration: textDecoration,
    as: as,
    "aria-label": as === 'span' ? children : undefined,
    screenReaderOnly: screenReaderOnly
  }), children);
});
//# sourceMappingURL=FloraTypography.js.map